export function notNullish(value: unknown) {
  return !(value === undefined) && !(value === null);
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number";
}

export type Subset<T, U extends T> = U;
